// client/hooks/util.ts
import { LocalStorageReactive } from "@adornis/base/rxjs-extension/reactives/client/local-storage.js";
var defaultTrackingSettings = {};
var EVENTLOGSETTINGS = new LocalStorageReactive("_adornis_eventlog_settings", {});
var registerTracking = (defaults) => {
  import("../hooks/index.js");
  defaultTrackingSettings = defaults;
};
export {
  EVENTLOGSETTINGS,
  defaultTrackingSettings,
  registerTracking
};
